<div class="placeme-status-gauge">
  <div class="placeme-status-gauge__imgs">
    <div
      *ngFor="let profile of profiles"
      [style.backgroundImage]="'url(' + profile.seo.image.url + ')'"
      class="placeme-status-gauge__imgs__items"
    ></div>
  </div>

  <div class="placeme-status-gauge__statusProgress">
    <span class="placeme-status-gauge__statusProgress__bar" [style.width]="progressValue + '%'"></span>
  </div>

  <div class="placeme-status-gauge__labels">
    <div
      *ngFor="let profile of profiles"
      [style.backgroundColor]="profile.backgroundColor"
      [style.color]="profile.backgroundColor"
      [style.width]="100 / profiles.length + '%'"
      class="placeme-status-gauge__labels__item"
    >
      <p [style.color]="profile.color">
        {{ profile.name }}
      </p>
    </div>
  </div>
</div>
